import * as API from '../_api';
import * as Sentry from '@sentry/vue';

// @ts-ignore
export const read = async ({commit, dispatch}) => {
  try {
    const all = await API.read();
    commit('setAll', all);
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', {root: true});
    return false;
  }
};

// @ts-ignore
export const readOne = async ({commit, dispatch}, {id}) => {
  try {
    const one = await API.readOne(id);
    commit('setOne', one);
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', {root: true});
    return false;
  }
};

// @ts-ignore
export const update = async ({commit, dispatch}, host) => {
  try {
    await API.update(host);
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', ex, {root: true});
    return false;
  }
};

// @ts-ignore
export const create = async ({commit, dispatch}, host) => {
  try {
    return await API.create(host);
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', ex, {root: true});
    return false;
  }
};

// @ts-ignore
export const remove = async ({commit, dispatch}, {id}) => {
  try {
    await API.del(id);
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', {root: true});
    return false;
  }
};

